import { render } from "./wxModel.vue?vue&type=template&id=68db6cea&scoped=true&ts=true"
import script from "./wxModel.vue?vue&type=script&lang=ts"
export * from "./wxModel.vue?vue&type=script&lang=ts"

import "./wxModel.vue?vue&type=style&index=0&id=68db6cea&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68db6cea"]])

export default __exports__